<template>
  <div class="card p-3">
    <div
      v-if="this.errosValidacaoGeral.length"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            <ul>
              <li v-for="value in this.errosValidacaoGeral" :key="value">
                {{ value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="card-header ps-5 pe-5 pt-0 pb-0 border-0">
      <div class="card-title">
        <div class="d-flex align-items-center position-relative my-1">
          <span class="svg-icon svg-icon-1 position-absolute ms-6">
            <inline-svg src="media/icons/duotune/general/gen004.svg" />
          </span>
          <input
            id="txtPesquisarAdicionaisGrupos"
            type="text"
            v-model="tableData.search"
            @input="onSearch($event.target.value)"
            class="form-control form-control-solid w-300px ps-15"
            placeholder="Pesquisar Adicionais Grupos"
          />
        </div>
      </div>
      <div class="card-toolbar">
        <div
          v-if="checkedAdicionaisGrupo.length === 0"
          class="d-flex justify-content-end"
          data-kt-customer-table-toolbar="base"
        >
          <button
            @click="this.$refs.table.exportarExcel()"
            type="button"
            class="btn btn-sm btn-light-primary me-3"
          >
            <span class="svg-icon svg-icon-2">
              <inline-svg src="media/icons/duotune/arrows/arr078.svg" />
            </span>
            Exportar
          </button>
          <button
            type="button"
            v-if="this.adicionar"
            class="btn btn-sm btn-primary"
            @click="$emit('adicionarAdicionalGrupo')"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen041.svg" /></span
            >Adicionar Grupo
          </button>
        </div>
        <div
          v-else
          class="d-flex justify-content-end align-items-center"
          data-kt-customer-table-toolbar="selected"
        >
          <div class="fw-bolder me-5">
            <span class="me-2">{{ checkedAdicionaisGrupo.length }}</span
            >Selecionado(s)
          </div>
          <button
            v-if="this.excluir"
            type="button"
            class="btn btn-sm btn-danger"
            @click="deleteSelecionados()"
          >
            Excluír Selecionado(s)
          </button>
        </div>
      </div>
    </div>
    <div class="card-body ps-5 pe-5 pt-0 pb-0">
      <Datatable
        ref="table"
        :table-header="tableHeader"
        :table-data="tableData"
        :table-pagination="tablePagination"
        :page-sizes="pageSizes"
        :enable-items-per-page-dropdown="true"
        :hide-on-single-page="false"
        empty-table-text="Nenhum grupo de adicional encontrado"
        @checked-rows="checkedAdicionaisGrupo = $event"
        :colors="true"
      >
        <template v-slot:cell-checkbox="{ row: adicionalGrupo }">
          <div
            class="form-check form-check-sm form-check-custom form-check-solid"
          >
            <input
              class="form-check-input"
              type="checkbox"
              :value="adicionalGrupo.id"
              v-model="checkedAdicionaisGrupo"
            />
          </div>
        </template>
        <template v-slot:cell-id="{ row: adicionalGrupo }">
          {{ adicionalGrupo.id }}
        </template>
        <template v-slot:cell-imagem="{ row: adicionalGrupo }">
          <div v-if="adicionalGrupo.imagem" class="symbol symbol-50px">
            <div
              class="symbol-label fs-2 fw-bold bg-light-dark"
              :style="{
                'background-image': `url(${
                  this.$utils.getUrl() + adicionalGrupo.imagem
                })`,
              }"
            ></div>
          </div>
          <div v-else class="symbol symbol-50px">
            <div :class="['symbol-label fs-2 fw-bold ' + adicionalGrupo.color]">
              {{
                adicionalGrupo.descricao
                  ? adicionalGrupo.descricao.substring(0, 1).toUpperCase()
                  : ""
              }}
            </div>
          </div>
        </template>
        <template v-slot:cell-descricao="{ row: adicionalGrupo }">
          <div class="align-middle">
            <div>
              <span class="text-dark text-hover-primary mb-1 fs-4">
                {{ adicionalGrupo.descricao }}
              </span>
            </div>
          </div>
        </template>
        <template v-slot:cell-cod_referencia="{ row: adicionalGrupo }">
          {{ adicionalGrupo.cod_referencia }}
        </template>
        <template v-slot:cell-obrigatorio="{ row: adicionalGrupo }">
          <div
            class="form-check form-check-sm form-check-custom form-check-danger form-check-solid"
          >
            <input
              class="form-check-input"
              type="checkbox"
              :checked="this.$utils.stringToBoolean(adicionalGrupo.obrigatorio)"
              disabled
            />
          </div>
        </template>
        <template v-slot:cell-multipla_selecao="{ row: adicionalGrupo }">
          <div
            class="form-check form-check-sm form-check-custom form-check-danger form-check-solid"
          >
            <input
              class="form-check-input"
              type="checkbox"
              :checked="
                this.$utils.stringToBoolean(adicionalGrupo.multipla_selecao)
              "
              disabled
            />
          </div>
        </template>
        <template v-slot:cell-ativo="{ row: adicionalGrupo }">
          <span
            v-if="adicionalGrupo.ativo === '1'"
            class="badge badge-light-success"
            >Ativo</span
          >
          <span v-else class="badge badge-light-danger">Indisponível</span>
        </template>
        <template v-slot:cell-acoes="{ row: adicionalGrupo }">
          <div class="min-w-250px">
            <button
              v-if="this.consultarAdicionalGrupoItem"
              type="button"
              class="btn btn-sm btn-light btn-light-danger ms-2 my-2"
              @click="$emit('exibirAdicionalGrupoItem', adicionalGrupo.id)"
            >
              Adicionais Itens
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light btn-active-light-primary ms-2 my-2"
              data-kt-menu-trigger="click"
              data-kt-menu-placement="bottom-end"
              data-kt-menu-flip="top-end"
            >
              Ações
              <span class="svg-icon svg-icon-5 m-0">
                <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
              </span>
            </button>
            <div
              v-if="this.editar || this.excluir"
              class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
              data-kt-menu="true"
            >
              <div v-if="this.editar" class="menu-item px-3">
                <a
                  @click="$emit('editarAdicionalGrupo', adicionalGrupo.id)"
                  class="menu-link px-3"
                  >Editar</a
                >
              </div>
              <div v-if="this.excluir" class="menu-item px-3">
                <a
                  @click="removerRegistro(adicionalGrupo.id)"
                  class="menu-link px-3"
                  >Excluír</a
                >
              </div>
              <div
                v-if="this.editar && adicionalGrupo.ativo === '1'"
                class="menu-item px-3"
              >
                <a
                  @click="consultarRegistro(adicionalGrupo)"
                  class="menu-link px-3"
                  >Inativar</a
                >
              </div>
              <div
                v-if="this.editar && adicionalGrupo.ativo === '0'"
                class="menu-item px-3"
              >
                <a
                  @click="consultarRegistro(adicionalGrupo)"
                  class="menu-link px-3"
                  >Ativar</a
                >
              </div>
            </div>
          </div>
        </template>
      </Datatable>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: [
    "adicionarAdicionalGrupo",
    "editarAdicionalGrupo",
    "exibirAdicionalGrupoItem",
  ],
  components: {
    Datatable,
  },
  props: {
    idAdicional: { type: Number, required: true },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 5;
      this.$refs.table.setRowsPage(5);
      this.tableData.filterOData =
        "&$filter=id_adicional eq " + this.idAdicional;
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=id_adicional eq " +
          this.idAdicional +
          " and ( contains(descricao, '" +
          pesquisa +
          "') or contains(cod_referencia, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa + " )";
        } else {
          this.tableData.filterOData = this.tableData.filterOData + " )";
        }
      } else {
        this.tableData.filterOData =
          "&$filter=id_adicional eq " + this.idAdicional;
      }
    },
    async deleteSelecionados() {
      await this.$swal.showQuestionAlert(
        "Deseja remover os registros selecionados?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            for (var i = 0; i < this.checkedAdicionaisGrupo.length; i++) {
              await this.excluirAdicionalGrupo(this.checkedAdicionaisGrupo[i]);
            }
            if (this.excluiuCadastro === true) {
              toast.success("Grupos do adicional excluídos com sucesso!", {
                timeout: 3000,
              });
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async removerRegistro(id) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            await this.excluirAdicionalGrupo(id);
            if (this.excluiuCadastro === true) {
              toast.success("Grupo do adicional excluído com sucesso!", {
                timeout: 3000,
              });
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async excluirAdicionalGrupo(id) {
      var adicionalGrupo = null;
      try {
        var ret = await this.$store.dispatch(
          "adicionalGrupo/getAdicionalGrupo",
          id
        );
        if (ret.Success === true) {
          adicionalGrupo = ret.Data;
        }
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }

      for (var i = 0; i < adicionalGrupo.AdicionalGrupoItem.length; i++) {
        try {
          await this.$store.dispatch(
            "adicionalGrupoItem/deleteAdicionalGrupoItem",
            adicionalGrupo.AdicionalGrupoItem[i].id
          );
        } catch (error) {
          this.excluiuCadastro = false;
          this.errosValidacaoGeral.push(error.Message);
        }
      }

      try {
        await this.$store.dispatch("adicionalGrupo/deleteAdicionalGrupo", id);
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    async consultarRegistro(adicionalGrupo) {
      this.$refs.table.setLoading(true);
      try {
        var ret = await this.$store.dispatch(
          "adicionalGrupo/getAdicionalGrupo",
          adicionalGrupo.id
        );
        if (ret.Success === true) {
          await this.atualizarRegistro(ret.Data);
        }
      } catch (error) {
        await this.$swal.showErrorAlert(error.Message);
      }
      this.$refs.table.setLoading(false);
    },
    async atualizarRegistro(adicionalGrupo) {
      if (adicionalGrupo.ativo === "1") {
        adicionalGrupo.ativo = "0";
      } else {
        adicionalGrupo.ativo = "1";
      }

      var formData = this.$utils.convertModelToFormData(adicionalGrupo);
      try {
        var ret = await this.$store.dispatch(
          "adicionalGrupo/putAdicionalGrupo",
          formData
        );
        if (ret.Success === true) {
          this.$refs.table.load();
          toast.success("Grupo do adicional atualizado com sucesso!", {
            timeout: 2000,
          });
        }
      } catch (error) {
        await this.$swal.showErrorAlert(error.Message);
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.AdicionalGrupo.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.AdicionalGrupo.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.AdicionalGrupo.Excluir") {
            this.excluir = true;
          }

          if (element.regra === "Permitir.AdicionalGrupoItem.Consultar") {
            this.consultarAdicionalGrupoItem = true;
          }
        });
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    this.$utils.requestFocus("txtPesquisarAdicionaisGrupos");
  },
  data() {
    return {
      consultarAdicionalGrupoItem: false,
      adicionar: false,
      editar: false,
      excluir: false,
      checkedAdicionaisGrupo: [],
      errosValidacaoGeral: [],
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          key: "imagem",
          sortable: false,
        },
        {
          name: "Descrição",
          key: "descricao",
          sortable: true,
        },
        {
          name: "Referência",
          key: "cod_referencia",
          sortable: true,
        },
        {
          name: "Obrigatório",
          key: "obrigatorio",
          sortable: false,
        },
        {
          name: "Múlt. Escolha",
          key: "multipla_selecao",
          sortable: false,
        },
        {
          name: "Situação",
          key: "ativo",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "adicionalGrupo/getAdicionalGrupoOData",
        selectOData:
          "?$select=id,id_adicional,descricao,obrigatorio,multipla_selecao,ordem,ativo,guid,cod_referencia,imagem,minimo,maximo,limitar_selecao",
        filterOData: "&$filter=id_adicional eq " + this.idAdicional,
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 5,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
